import { Breadcrumb, Carousel, Col, Row } from "react-bootstrap";
import "./About.css";
import Header from "./Header";
import {useNavigate } from "react-router-dom";
import aboutimg from "../assets/images/about-img.jpg";
import Footer from "./Footer";
function AboutUs() {
  const navigate = useNavigate();

  return (
    
    <>
    <div className="about">
      <div style={{ height: "130px" }}>
        <Header />
      </div>
      <div className="banner text-center">
        <h2>About</h2>
        <p className="banner-text">
          Flora Infotech is a growing IT company offering expert solutions in
          web development, <br /> app development, and web design. We are
          committed to delivering creative, scalable, <br /> and efficient
          digital solutions that help businesses succeed in today’s competitive
          landscape.
        </p>
        <div className="d-flex justify-content-center mt-4">
          <Breadcrumb style={{ color: "white" }} className="text-center mt-3">
            <Breadcrumb.Item className="item" onClick={()=>{navigate('/')}} >
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="item" href="" active>
              About Us
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <div className="container margin-top about-section">
        <Row className="d-flex align-items-center justify-content-between">
          <h2 className="text-center">About Us</h2>
          <Col lg={6} md={6} sm={12} className="mt-3">
            <p>
              At Flora Infotech, we are passionate about transforming ideas into
              innovative digital solutions. As a dynamic and forward-thinking
              technology company, we specialize in web development, app
              development, and web design services tailored to meet the unique
              needs of businesses across various industries.
            </p>
            <p>
              With a team of skilled developers, creative designers, and tech
              enthusiasts, we focus on delivering high-quality, user-centric
              solutions that drive growth and enhance user experience. Whether
              it's building responsive websites, developing powerful mobile
              applications, or crafting intuitive user interfaces, our
              commitment to excellence ensures that every project is executed
              with precision and professionalism.
            </p>
          </Col>
          <Col lg={6} md={6} sm={12} className="text-end mt-3">
            <img src={aboutimg} className="aboutimg" alt="" style={{ height: "450px" }} />
          </Col>
        </Row>
      </div>
     
      <div className="carousel-container margin-top">
      {/* Static Background */}
      <div className="carousel-background"></div>
      
      {/* Carousel with Content */}
      <div className="carousel-content">
        <Carousel controls={true} indicators={true} interval={4000}>
          <Carousel.Item>
            <div className="carousel-item-content">
              <h2 className="display-3">Web Development</h2>
              <p className="lead mt-2 banner-text">We build fast, secure, and scalable websites tailored to your business needs. <br />
                From responsive layouts to dynamic functionality, our development ensures performance across all devices.</p>
            </div>
          </Carousel.Item>
          
          <Carousel.Item>
            <div className="carousel-item-content">
              <h2 className="display-3">Mobile App Development</h2>
              <p className="lead mt-2 banner-text">From idea to launch, we develop powerful mobile apps for iOS and Android. <br />
                 Our apps are feature-rich, user-centric, and built for performance and scalability.</p>
            </div>
          </Carousel.Item>
          
          <Carousel.Item>
            <div className="carousel-item-content">
              <h2 className="display-3">Web Design</h2>
              <p className="lead mt-2 banner-text">Our creative team crafts modern, user-friendly designs that capture attention and enhance user <br />
                 We focus on clean aesthetics, intuitive navigation, and responsive layouts.</p>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
     <div className="container mission-div margin-top mb-5">
      <div className="text-center">
        <h2>Our Mission</h2>
        <div className="underline"></div>
        <p className="mt-3">Our mission is to deliver innovative, reliable, and result-driven digital solutions <br /> that empower businesses to thrive in a fast-paced digital world.</p>
        <p>We aim to create high-performance websites, mobile apps, and user-friendly interfaces  <br /> that not only meet our clients' needs but also exceed their expectations.</p>
      </div>
      <div className="text-center margin-top">
        <h2>Our Vision</h2>
        <div className="underline"></div>
        <p className="mt-3">Our vision is to become a globally recognized leader in web and mobile technology services, <br /> known for our innovation, quality, and customer-centric approach.</p>
        <p>We envision a future where businesses of all sizes leverage our digital expertise <br /> to transform their ideas into impactful online experiences.</p>
      </div>
      </div>
      <Footer />
      </div>
    </>
  );
}

export default AboutUs;
